import script from "./BindWxDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./BindWxDialog.vue?vue&type=script&lang=ts&setup=true"

import "./BindWxDialog.vue?vue&type=style&index=0&id=fa2b04ca&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa2b04ca"]])

export default __exports__